import { useEffect } from 'react';

import Order from '@/shared/types/order/order.type';
import QuoteResponse from '@/shared/types/order/quotes/quoteResponse.type';
import ProductOrder from '@/shared/types/productOrder.type';

import useCart from '../../components/Cart/hooks/useCart';

const useCartInitialization = (
  cartState: ReturnType<typeof useCart>,
  order: Order | null,
  orderQuote: QuoteResponse | null,
) => {
  useEffect(() => {
    if (cartState.productsInCart.length === 0 && order && orderQuote) {
      const products = order.products.map((productItem) => {
        const productInfoInQuote = orderQuote.quote.find(
          (quoteItem) => quoteItem.product_id === productItem.product_id,
        );

        const newProductItem = {
          ...productItem,
          ...productInfoInQuote,
        };

        return {
          ...newProductItem,
          value: newProductItem.price,
          id: newProductItem.variant_id || newProductItem.product_id,
          name: newProductItem.variant_name || newProductItem.product_name,
          sku: '',
        };
      });

      products.forEach((product) => {
        cartState.addProductToCart(product as ProductOrder);
      });

      cartState.onAssignQuote(orderQuote);
    }
  }, [cartState, order, orderQuote]);
};

export default useCartInitialization;
